import axios from 'axios';

const BASE = app_endpoint;
const BASE_URL = BASE + '/api/';

export const url = BASE;

export const post = async(endpoint, payload) => {
    try {
        const response = await axios(BASE_URL + endpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            data: payload,
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const get = async(endpoint) => {
    try {
        const response = await axios(BASE_URL + endpoint, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};
